module.exports = __webpack_public_path__ + "static/media/disconnect.bc38e30e.webp";